export enum AdminApiMemberDataFieldName {
  Status = "Status",
  Gender = "Gender",
  MemberLevel = "MemberLevel",
  MemberLevelDescription = "MemberLevelDescription",
  MembershipType = "MembershipType",
  MembershipTypeDescription = "MembershipTypeDescription",
}
